import { useEffect, useState } from 'react';

import { SearchInput } from 'ui';
import { useDebouncedValue } from 'ui/Hooks';

import { useUserPurchasesSearchContext } from '../PurchaseSearchContext';

const PurchaseSearchInput = ({ isPurchasesEmpty }: { isPurchasesEmpty: boolean }) => {
  const ctx = useUserPurchasesSearchContext();
  const [search, setSearch] = useState('');
  const [debounced] = useDebouncedValue(search, 500);

  useEffect(() => {
    ctx.setUserPurchasesSearchObject({
      searches: {
        ...ctx.UserPurchasesSearchObject?.searches,
        'store_items.name': {
          value: debounced,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Adding ctx will cause infinite loop
  }, [debounced]);

  return (
    <>
      <SearchInput
        disabled={isPurchasesEmpty}
        placeholder="Search Purchases"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </>
  );
};

export { PurchaseSearchInput };
